import axios from 'axios'

// 创建 axios 实例
const service = axios.create({
	// baseURL: 'http://192.168.0.108:3189', // 基础路径
	baseURL: "https://api.longbu2026.com",
	timeout: 5000 // 请求超时时间
})

// request 拦截器
service.interceptors.request.use(
	config => {
		// 在发送请求之前做些什么
		const token = localStorage.getItem('token')
		if (token) {
			// config.headers['token'] = 'Bearer' + ' ' +token
			// config.header["token"] = uni.getStorageSync('token'); // 携带token
			// configheader['content-type'] = 'application/json;charset=UTF-8'
			// header['Authorization'] = 'Bearer' + ' ' + uni.getStorageSync('token')

			config.headers["token"] = token; // 携带token
			if (!(config.data instanceof FormData)) {
				config.headers['content-type'] = 'application/json;charset=UTF-8'
			}
			config.headers['Authorization'] = 'Bearer' + ' ' + token
		}
		return config
	},
	error => {
		// 对请求错误做些什么
		console.log(error) // for debug
		return Promise.reject(error)
	}
)

// response 拦截器
service.interceptors.response.use(
	response => {
		const res = response.data
		// 这里可以根据后端的 code 进行统一处理
		// 假设 code !== 200 是错误
		if (res.code !== 200) {
			// 特殊处理 402：未绑定手机号/未注册，不抛出错误，交由业务逻辑处理
			if (res.code === 402) {
				return res
			}
			const message = res.msg || res.message || 'Error'
			console.error('API Error:', message)
			return Promise.reject(new Error(message))
		} else {
			// 如果有 rows 字段，通常是分页列表，返回整个对象以便获取 total 等信息
			if (res.rows) {
				return res
			}
			// 否则尝试返回 data；若 data 为 null/undefined，返回 res，保证调用方能拿到 code、message
			return (res.data !== undefined && res.data !== null) ? res.data : res
		}
	},
	error => {
		console.log('err' + error) // for debug
		return Promise.reject(error)
	}
)

export default service